import {projectCardClasses as classes, ProjectCardSkeletonRoot} from "@buildwithflux/project-cards";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

/**
 * Skeleton stand-in for a unified project card whose data hasn't loaded yet.
 * Reuses the shared card's root and class structure so its dimensions and
 * spacing are identical to a loaded card.
 */
export default function UnifiedProjectCardSkeleton() {
    return (
        <ProjectCardSkeletonRoot className={classes.cardWrapper} component="li" elevation={0} uniformHeight>
            <Box className={classes.cardInner}>
                <Box className={classes.thumbnailWrapper}>
                    <Skeleton variant="rectangular" width={100} height={100} />
                </Box>
                <Box className={classes.content}>
                    <Box className={classes.topSection}>
                        <Typography variant="h6" component="h3" className={classes.name}>
                            <Skeleton width="35%" />
                        </Typography>
                        <Typography component="div" variant="body2" className={classes.description}>
                            <Skeleton width="100%" />
                            <Skeleton width="65%" />
                        </Typography>
                        <Box className={classes.authorRow}>
                            <Box className={classes.authorRowInner}>
                                <Skeleton variant="circular" width={20} height={20} />
                                <Typography variant="body2">
                                    <Skeleton width={80} />
                                </Typography>
                                <Typography variant="body2">
                                    <Skeleton width={60} />
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <div className={classes.metricRow}>
                        <div className={classes.metricRowInner}>
                            <Typography variant="body2">
                                <Skeleton width={60} />
                            </Typography>
                            <Typography variant="body2">
                                <Skeleton width={90} />
                            </Typography>
                            <Typography variant="body2">
                                <Skeleton width={70} />
                            </Typography>
                        </div>
                    </div>
                </Box>
            </Box>
        </ProjectCardSkeletonRoot>
    );
}
